import "./_grilleTarifaireOperationCommercial.scss";

import cx from "classnames";
import Decimal from "decimal.js";
import {ReactElement, useState} from "react";

import iconChartDown from "@/assets/massification/iconChartDown.png";
import SelectCustom from "@/components/SelectCustom/SelectCustom";
import {
  FormatOption,
  itemOffre,
  OffreOperationCommerciale,
} from "@/ts/interface/operationCommerciale";
import {Livraison} from "@/ts/interface/operationCommerciale";

type prixUnitaireGrille = {
  type: "Formats" | "Options" | "Livraisons";
  isNotBasicPrice?: boolean;
  id: number | undefined;
  nom: string;
  prixUnitaire: string;
};
type prixPalierGrille = {
  palier: number;
  valeur: prixUnitaireGrille[];
};
// récupère les prix des livraisons, formats et option et les regroupes par palier
const formatPrixPalier = (item: itemOffre): prixPalierGrille[] => {
  const allPalier: prixPalierGrille[] = [];
  const {formats = [], options = [], livraisons = []} = item;
  const addPalier = (
    tableau: FormatOption[] | Livraison[],
    type: "Formats" | "Options" | "Livraisons",
  ): void => {
    tableau.forEach(element => {
      element.prix.forEach(prix => {
        const elementToAdd = {
          type: type,
          nom: "nom" in element ? element?.nom : element?.type,
          id:
            "livraison_id" in element
              ? element?.livraison_id
              : element?.item_format_id || element?.item_option_id,

          prixUnitaire: prix.prix_unitaire,
        };
        if (!allPalier.some(palier => palier.palier === prix.palier)) {
          allPalier.push({
            palier: prix.palier,
            valeur: [elementToAdd],
          });
        } else {
          const palierIndex = allPalier.findIndex(element => {
            return element.palier === prix.palier;
          });
          allPalier[palierIndex].valeur.push(elementToAdd);
        }
      });
    });
  };
  addPalier(formats, "Formats");
  addPalier(options, "Options");
  addPalier(livraisons, "Livraisons");
  allPalier.sort((a, b) => {
    return a.palier - b.palier;
  });
  return allPalier;
};

// récupérer les tarifs applicable en fonction de la quantité.
const getTarifInPalier = (
  allPalier: prixPalierGrille[],
  quantite: number,
): prixUnitaireGrille[] => {
  const filtredPalier = allPalier.filter(palier => palier.palier <= quantite);

  const currentTarif = filtredPalier[0]?.valeur;
  if (currentTarif?.length > 0) {
    filtredPalier.slice(1).forEach(palier => {
      palier.valeur?.forEach(element => {
        const tarfiIndex = currentTarif.findIndex(
          current => current.id === element.id && current.type === element.type,
        );
        currentTarif[tarfiIndex] = {...element, isNotBasicPrice: true};
      });
    });
  }
  return currentTarif;
};

function TarifItem({item}: {item: itemOffre}): ReactElement {
  const allPalier = formatPrixPalier(item);
  const [quantitePalier, setQuantitePalier] = useState<number>(
    allPalier[0]?.palier || 1,
  );
  const currentPalier = getTarifInPalier(allPalier, quantitePalier);
  const typePrint: string[] = [];
  const allTarif = currentPalier.map((palier, index) => {
    let type = null;
    if (!typePrint.includes(palier.type)) {
      type = <p className="grillePalier-celule--type">{palier.type}</p>;
      typePrint.push(palier.type);
    }
    const palierPrixUnitaire =
      palier.prixUnitaire === "NaN" ? "0" : palier.prixUnitaire;
    return (
      <div className="grillePalier-celule" key={index}>
        {type}
        <p className="grillePalier-celule--prix">
          {palier.nom}
          <span className={cx(palier.isNotBasicPrice ? "greenColor" : "")}>
            (+{new Decimal(palierPrixUnitaire).toFixed(2).toString()}€)
            {palier.isNotBasicPrice ? (
              <img
                src={iconChartDown}
                alt="icon de graphique avec flêche vers le bas"
              />
            ) : null}
          </span>
        </p>
      </div>
    );
  });
  const selectOption = allPalier.map(palier => {
    return {libelle: palier.palier, value: palier.palier};
  });
  return (
    <div className="tarifItem">
      <h3>{item.nom}</h3>
      {selectOption.length > 1 ? (
        <SelectCustom
          label="Palier"
          handleSelect={value => setQuantitePalier(value)}
          options={selectOption}
          defaultValue={quantitePalier.toString()}
          name="quantiteForPalier"
        />
      ) : null}
      <div className="grillePalier-ligne">
        {/* <div className="grillePalier-celule--palier">{palier.palier}</div> */}
        <div className="grillePalier-ligne--info"> {allTarif}</div>
      </div>
    </div>
  );
}

function GrilleTarifaireOperationCommercial({
  offre,
}: {
  offre: OffreOperationCommerciale;
}): ReactElement {
  const itemsPrix = offre?.items?.map(item => {
    return <TarifItem item={item} key={item.item_id} />;
  });
  return <div className="grillePalier">{itemsPrix}</div>;
}

export default GrilleTarifaireOperationCommercial;
